import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import DateTimeInputRaw from '~/components/common/DateTimeInput'

const DateTimeInput = ({ field, form, disabled, ...props }) => (
  <DateTimeInputRaw
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    {...field}
    onChange={(newVal) => form.setFieldValue(field.name, newVal)}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

DateTimeInput.defaultProps = {
  disabled: false,
}

DateTimeInput.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default DateTimeInput
